export const addSortFieldToCompanies = (companies: any[]): any[] => {
  return companies.map((company: any) => {
    company.sortable_name = company.name.replace(/\(/g, '').replace(/\)/g, '').toLocaleLowerCase();
    return company;
  });
};
